// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SIGNUP_PHONE_WE_SENT_YOU_NEW_ACTIVATION_CODE_SMS = "Poslali sme ti nov\u00fd aktiva\u010dn\u00fd k\u00f3d.";
export const YOU_WERE_SUCCESSFULLY_LOGGED_IN_AS_username = "Pr\u00e1ve si sa prihl\u00e1sila ako pou\u017e\u00edvate\u013eka %(username)s.";
